// src/screens/TermsOfService.js
import React from 'react';
import './TermsOfService.css';
import backIcon from '../assets/backspace-icon.png';
import Screen from '../Screen';
import { useTranslation, Trans } from 'react-i18next';

function TermsOfService() {
  const { t } = useTranslation();

  const goBack = () => {
    if (window.history.length <= 1) {
      window.location.href = '/home';
    } else {
      window.history.back();
    }
  };

  return (
    <Screen>
      <div className="terms-container">
        <div className="terms-topbar">
          <img
            src={backIcon}
            alt={t('tos.back')}
            className="terms-back-icon"
            onClick={goBack}
          />
          <h2 className="terms-title">{t('tos.title')}</h2>
        </div>

        <div className="terms-scroll-area">
          <div className="terms-content">
            <h3>{t('tos.welcome.title')}</h3>
            <p>{t('tos.welcome.body')}</p>

            <h4>{t('tos.eligibility.title')}</h4>
            <p>{t('tos.eligibility.body')}</p>

            <h4>{t('tos.accounts_wallets.title')}</h4>
            <ul>
              <li>{t('tos.accounts_wallets.points.security')}</li>
              <li>
                <Trans i18nKey="tos.accounts_wallets.points.activation">
                  Each user has an in-app wallet. To activate it, you must top up with at least <strong>0.1&nbsp;Pi</strong>.
                </Trans>
              </li>
              <li>
                <Trans i18nKey="tos.accounts_wallets.points.sdk">
                  BarterFi uses the official Pi SDK for <strong>App-to-User (A2U)</strong> payments recorded on-chain. <strong>User-to-User (U2U)</strong> transfers inside the app (e.g., tips, purchases) are handled via your in-app wallet balance.
                </Trans>
              </li>
              <li>{t('tos.accounts_wallets.points.keys')}</li>
            </ul>

            <h4>{t('tos.marketplace.title')}</h4>
            <ul>
              <li>{t('tos.marketplace.points.approved')}</li>
              <li>{t('tos.marketplace.points.accurate')}</li>
              <li>{t('tos.marketplace.points.removal')}</li>
            </ul>

            <h4>{t('tos.escrow.title')}</h4>
            <p>{t('tos.escrow.body')}</p>

            <h4>{t('tos.payments_fees.title')}</h4>
            <p>{t('tos.payments_fees.intro')}</p>
            <ul>
              <li>
                <Trans i18nKey="tos.payments_fees.items.escrow_commission">
                  <strong>Escrow sales commission:</strong> 10% per sale. The seller receives 90% of the final order amount after buyer confirmation.
                </Trans>
              </li>
              <li>
                <Trans i18nKey="tos.payments_fees.items.tipping_fee">
                  <strong>Tipping fee:</strong> 5% per tip. The creator/receiver keeps 95% of the tip.
                </Trans>
              </li>
              <li>
                <Trans i18nKey="tos.payments_fees.items.merchant_subscription">
                  <strong>Merchant subscription:</strong> 20&nbsp;Pi per 30-day cycle for a verified store.
                </Trans>
              </li>
              <li>
                <Trans i18nKey="tos.payments_fees.items.sponsored_promo">
                  <strong>Sponsored promotion:</strong> 15&nbsp;Pi per product/service promotion, active for 7 days.
                </Trans>
              </li>
            </ul>
            <p>{t('tos.payments_fees.details')}</p>

            <h4>{t('tos.prohibited.title')}</h4>
            <ul>
              <li>{t('tos.prohibited.items.fraud')}</li>
              <li>{t('tos.prohibited.items.hate')}</li>
              <li>{t('tos.prohibited.items.circumvent')}</li>
            </ul>

            <h4>{t('tos.suspension.title')}</h4>
            <p>{t('tos.suspension.body')}</p>

            <h4>{t('tos.in_app_payments.title')}</h4>
            <p>{t('tos.in_app_payments.body')}</p>
            <ul>
              <li>{t('tos.in_app_payments.items.no_liability')}</li>
              <li>{t('tos.in_app_payments.items.no_refunds_offplatform')}</li>
            </ul>

            <h4>{t('tos.refunds_disputes.title')}</h4>
            <p>{t('tos.refunds_disputes.body1')}</p>
            <p>{t('tos.refunds_disputes.body2')}</p>

            <h4>{t('tos.withdrawals.title')}</h4>
            <p>
              <Trans i18nKey="tos.withdrawals.body1">
                You may request a Pi withdrawal from your in-app wallet by submitting a destination wallet address.
                This must be a valid <strong>Pi Mainnet</strong> wallet address under your control. BarterFi will never
                send Pi to a third-party address on your behalf.
              </Trans>
            </p>
            <p>{t('tos.withdrawals.body2')}</p>
            <p>
              <Trans i18nKey="tos.withdrawals.warning">
                <strong>Warning:</strong> If you enter an incorrect wallet address, the Pi will be sent and
                <u>cannot be recovered</u>. Double-check your destination address before confirming your request.
              </Trans>
            </p>

            <h4>{t('tos.privacy.title')}</h4>
            <p>{t('tos.privacy.body')}</p>

            <h4>{t('tos.changes.title')}</h4>
            <p>{t('tos.changes.body')}</p>

            <p style={{ marginTop: 30, fontSize: 14, color: '#888' }}>
              {t('tos.last_updated', { date: 'September 30, 2025' })}
            </p>
          </div>
        </div>
      </div>
    </Screen>
  );
}

export default TermsOfService;
